import React from "react";
import { motion } from "framer-motion";
import { ShieldCheck, Search, FileMinus, Info } from "lucide-react";

const CARDS = [
  {
    Icon: ShieldCheck,
    title: "ثبت کدهای بین‌المللی",
    text: "دریافت کدهای رسمی UPC و ISRC برای هر اثر جهت تثبیت مالکیت شما در سطح جهانی.",
  },
  {
    Icon: Search,
    title: "فعالسازی Content ID",
    text: "ثبت اثر در سیستم اثرانگشت دیجیتال برای شناسایی و نقد کردن درآمد از استفاده‌های غیرمجاز.",
  },
  {
    Icon: FileMinus,
    title: "محافظت و پیگیری حقوقی",
    text: "امکان ارسال کلیم (Claim) و حذف محتوای ناقض حقوق شما در تمام پلتفرم‌ها با پشتیبانی ما.",
  },
];

export default function Licensing() {
  return (
    <section className="py-20 md:py-28 relative">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="max-w-3xl">
          <h2 className="mt-2 text-3xl md:text-4xl font-bold tracking-tight">
            لایسنس، مالکیت و <span className="gradient-text-neon">محافظت از اثر شما</span>
          </h2>
          <p className="mt-5 text-slate-300 leading-relaxed">
            ما در فرآیند انتشار، اطلاعات مالکیت و لایسنس موزیک شما را به طور رسمی ثبت و مدیریت می‌کنیم تا با خیال راحت از حقوق معنوی اثرتان مطمئن باشید.
          </p>
        </div>

        <div className="mt-12 grid md:grid-cols-3 gap-5">
          {CARDS.map((c, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 18 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              className="glass glass-hover rounded-3xl p-7 transition-all"
              data-testid={`licensing-card-${i}`}
            >
              <div className="w-12 h-12 rounded-2xl bg-white/[0.04] border border-white/10 flex items-center justify-center mb-5">
                <c.Icon className="w-5 h-5 text-purple-200" strokeWidth={1.6} />
              </div>
              <h3 className="text-lg font-bold mb-2">{c.title}</h3>
              <p className="text-sm text-slate-300 leading-relaxed">{c.text}</p>
            </motion.div>
          ))}
        </div>

        <div className="mt-8 glass rounded-2xl p-4 flex items-start gap-3 max-w-3xl">
          <Info className="w-5 h-5 text-cyan-300 shrink-0 mt-0.5" />
          <p className="text-sm text-slate-300 leading-relaxed">
            نتیجه نهایی هر Claim یا درخواست حذف، وابسته به قوانین، بررسی و تصمیم پلتفرم مربوطه است.
          </p>
        </div>
      </div>
    </section>
  );
}
